import "./css/AbsoluteLoader.scss";
import { Loader } from "@common/Loader/Loader";

interface IParams {
    size?: number;
}

export const AbsoluteLoader = (props: IParams) => {
    const { size } = props;

    return (
        <div className="loader-container">
            <Loader size={size} />
        </div>
    );
};
